t = require('views/internal/teacup-with-helpers')('header_warning_account_transfer_required_delayed')

module.exports = t.renderable ({ enterpriseName }) ->
  t.p '.u-bottom', ->
    t.p ->
      t.format 'no-converted-admin'
      t.text " "
      t.a '.quiet', { href: "/enterprise/#{ enterpriseName }/transfer-account" }, ->
        t.format 'convert-now'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_account_transfer_required_delayed.coffee